/**
 * Returns to the root userareaWrapper as long as the passed element exists
 * within the user-area
 */
function getUserareaWrapper(element) {
  if (!element) {
    const target = document.querySelector("[data-user-area-wrapper]");
    if (target instanceof HTMLElement) {
      return target;
    }
  }
  let currElement = element?.parentElement ?? null;
  while (currElement !== null) {
    if (currElement.dataset["isWrapper"]) {
      break;
    }
    currElement = currElement.parentElement;
  }
  if (!currElement) {
    throw new Error("getUserareaWrapper(): An ancestor HTMLElement must be defined as a wrapper-element!");
  }
  return currElement;
}

export { getUserareaWrapper };
//# sourceMappingURL=getUserareaWrapper.js.map
